<template>
  <!-- 申诉反馈弹窗 -->
  <div>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="申诉反馈流程"
      :visible.sync="dialogVisible"
      width="484px"
      append-to-body
    >
      <!--  -->
      <el-form
        style="margin: 20px 0 20px 35px"
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="126px"
        class="demo-ruleForm"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item class="left" label="申诉类型：" prop="appealType">
              <el-select
                v-model="ruleForm.appealType"
                class="ccui-form-longInput"
                placeholder="请选择"
                filterable
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in applyReasonOptions"
                  :key="item.dicKey"
                  :label="item.dicValue"
                  :value="item.dicKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item class="left" label="申诉标题：" prop="appealTitle">
              <el-input
                v-model="ruleForm.appealTitle"
                class="ccui-form-longInput input-word-limit"
                placeholder="请输入"
                show-word-limit
                maxlength="50"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item class="left" label="申诉理由及详情：" prop="remark">
              <el-input
                type="textarea"
                placeholder="请输入"
                maxlength="500"
                show-word-limit
                v-model="ruleForm.remark"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              class="left"
              label="相关证明材料(选填)："
              prop="attachmentList"
            >
              <div>
                <el-upload
                  :show-file-list="false"
                  v-model="ruleForm.attachmentList"
                  class="upload-demo"
                  drag
                  :action="uploadForm.action"
                  :data="formData"
                  multiple
                  :on-success="onSuccess"
                  :on-progress="onProgress"
                  :on-error="onError"
                  :before-upload="beforeAvatarUpload"
                  :headers="uploadForm.headers"
                  :accept="
                    getUploadFileRules.map(n => n.toLowerCase()).join(',')
                  "
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <div
                  v-if="
                    ruleForm.attachmentList &&
                      ruleForm.attachmentList.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in ruleForm.attachmentList"
                    :key="index"
                    class="file-list"
                    :title="item.fileName"
                  >
                    {{ item.fileName }}
                    <div class="paa">
                      <el-button
                        size="mini"
                        type="text"
                        @click="deleteFile(item)"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </div>
                <div class="fileTitle">点击或拖拽文件至此处上传</div>
                <div class="fileLimit">
                  支持PDF、Word、Excel、 单个文件不超过10MB
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn">
        <button class="custom-button" @click="handleFeedbackRecord">
          提交申诉申请
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/basa/utils";
import { saveSupAppealFeedback } from "../api";
export default {
  name: "appealFeedbackDialog",
  props: {
    reviewId: {
      type: String,
      default: () => ""
    },
    supCode: {
      type: String,
      default: () => ""
    },
    type: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      uploadLoading: null,
      uploadForm: {
        // action: `${addUrlPerFix(
        //   process.env.VUE_APP_BASEP_URL
        // )}/apis/basap/users/signup/uploadLogo`,
        action: addUrlPerFix(
          process.env.VUE_APP_BASE_URL + "/apis/jrw/oss/uploadFilePersNew"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      limit: 10,
      formData: {
        agentId: this.$router.history.current.query.a || 107197
      },
      ruleForm: {
        appealType: "",
        appealTitle: "",
        remark: "",
        attachmentList: []
      },
      rules: {
        appealType: [
          { required: true, message: "请选择申诉类型", trigger: "change" }
        ],
        appealTitle: [
          { required: true, message: "请输入申诉标题", trigger: "blur" }
        ],
        remark: [
          { required: true, message: "请输入申诉理由及详情", trigger: "blur" }
        ]
      },
      applyReasonOptions: [
        {
          dicKey: "1",
          dicValue: "准入审核申诉"
        },
        {
          dicKey: "9",
          dicValue: "问题反馈"
        }
      ],
      getUploadFileRules: [".pdf", ".PDF", ".doc", ".docx", ".xlsx", ".xls"]
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          if (this.$refs["ruleForm"]) {
            this.$refs["ruleForm"].clearValidate();
          }
          if (this.type) {
            this.applyReasonOptions = this.applyReasonOptions.filter(
              _ => _.dicKey != 1
            );
          }
        }
      }
    }
  },
  methods: {
    onProgress(event, file, fileList) {
      this.uploadLoading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    onError() {
      // "上传至服务器失败请重新上传"
      this.$message.error("上传至服务器失败请重新上传");
      this.uploadLoading.close();
    },
    onSuccess(res, file, fileList) {
      if (this.ruleForm.attachmentList.length < 10) {
        // this.$refs.ruleForm.validateField("attachmentList", valid => {
        //   if (valid) {
        //     this.$refs["ruleForm"].clearValidate("attachmentList");
        //   }
        // });
        let fileData = res.data[0];
        this.ruleForm.attachmentList.push({
          fileUrl: fileData.downloadUrl,
          fileName: fileData.fileName,
          fileSize: Math.round(fileData.fileSize / 1024),
          fileSumm: "",
          createTime: fileData.createTime,
          uploadId: fileData.uploadId
        });

        this.uploadLoading.close();
      } else {
        this.$message({
          type: "error",
          message: `最多上传${this.limit}个文件`
        });
        this.uploadLoading.close();
      }
    },
    beforeAvatarUpload(file) {
      const isLt10 = file.size < 10485760;
      if (!isLt10) {
        // "文件大小不超过10M!"
        this.$message({
          showClose: true,
          message: "文件大小不超过10M!",
          type: "error",
          duration: 0
        });
      }
      if (file.size === 0) {
        // "文件大小不可为0B!"
        this.$message({
          showClose: true,
          message: "文件大小不可为0B!",
          type: "error",
          duration: 0
        });
      }
      return isLt10 && file.size > 0;
    },
    deleteFile(item) {
      this.ruleForm.attachmentList.forEach(_ => {
        if (_.uploadId == item.uploadId) {
          this.ruleForm.attachmentList.splice(0, 1);
        }
      });
    },
    // 提交申诉申请
    handleFeedbackRecord() {
      this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          let params = {
            reviewTaskId: this.reviewId,
            supCode: this.supCode,
            appealTitle: this.ruleForm.appealTitle,
            appealType: this.ruleForm.appealType,
            remark: this.ruleForm.remark,
            attachmentList: this.ruleForm.attachmentList,
            isShowLoading: true
          };
          saveSupAppealFeedback(params).then(res => {
            if (res.data.code == "0") {
              this.dialogVisible = false;
              this.ruleForm = {
                appealType: "",
                appealTitle: "",
                remark: "",
                attachmentList: []
              };
              this.$emit("confirm");
            }
          });
        }
      });
    },
    handleClose() {
      this.ruleForm = {
        appealType: "",
        appealTitle: "",
        remark: "",
        attachmentList: []
      };
      this.$refs["ruleForm"].clearValidate();
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header .el-dialog__title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px !important;
  color: #4a4a4a !important;
}
/deep/ .left {
  .el-form-item__label {
    text-align: right !important;
  }

  .input-word-limit .el-input__inner {
    padding-right: 35px !important;
  }
}
/deep/ .el-form-item {
  margin-bottom: 20px !important;
}
.el-input,
.el-select,
.el-textarea {
  width: 249px !important;
}
/deep/ .upload-demo {
  margin-left: 38px;
}
/deep/ .el-upload-dragger {
  width: 80px !important;
  height: 80px !important;
  background: #f1f1f1 !important;
  border: 1px dashed #dfdfdf !important;
  line-height: 80px !important;
}
.el-icon-plus {
  font-size: 20px !important;
  color: rgb(153, 153, 153) !important;
  font-weight: 600 !important;
}
.fileTitle {
  width: 196px;
  height: 17px;
  margin-bottom: 3px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #9b9b9b;
  line-height: 18px;
  font-style: normal;
}
.fileLimit {
  width: 155px;
  height: 37px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #c9c9c9;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}
.btn {
  text-align: center;
  margin-bottom: 38px;
  .custom-button {
    width: 375px;
    height: 32px;
    background: #0089ef;
    border-radius: 2px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    border: none;
  }
}

.file-list {
  max-width: 170px;
  padding-right: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
  position: relative;
  .paa {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }
}
</style>
